import React from "react";

export default function ReloadIcon(props?: any) {

  const svgStyles: any = {
    width: props.width ? props.width : null,
    height: props.height ? props.height : null,
    fill: props.fill ? props.fill : null,
    margin: props.margin ? props.margin : null,
  };

  const filteredStyles = Object.keys(svgStyles)
  .filter(key => svgStyles[key] !== null && svgStyles[key] !== undefined)
  .reduce((acc: any, key) => {
    acc[key] = svgStyles[key];
    return acc;
  }, {});

  return (
    <svg       
      viewBox="0 0 14 14" 
      fill="none" 
      style={{...filteredStyles, fill : "none"}}
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8.96573 1.2593L9.37655 0.983972C9.49478 0.903995 9.57639 0.780328 9.60344 0.640176C9.63048 0.500024 9.60075 0.354868 9.52077 0.236641C9.44079 0.118413 9.31713 0.0367993 9.17697 0.00975246C9.03682 -0.0172944 8.89167 0.0124416 8.77344 0.0924189L7.16515 1.16753C7.05196 1.25156 6.97468 1.37522 6.94875 1.51378C6.92282 1.65234 6.95016 1.79559 7.0253 1.91486L8.1004 3.52752C8.18875 3.61839 8.30635 3.67512 8.43246 3.6877C8.55856 3.70028 8.68506 3.6679 8.78961 3.59628C8.89416 3.52467 8.97005 3.41841 9.00388 3.29628C9.0377 3.17414 9.02729 3.04398 8.97447 2.92878L8.53744 2.26012C9.78506 2.51221 10.9032 3.19779 11.6937 4.1954C12.4841 5.19301 12.896 6.43823 12.8562 7.71044C12.8164 8.98265 12.3276 10.1997 11.4763 11.146C10.625 12.0922 9.46629 12.7066 8.20536 12.8803C6.94443 13.0539 5.66274 12.7756 4.58737 12.0947C3.512 11.4138 2.71238 10.3741 2.33019 9.16005C1.94801 7.94595 2.00792 6.63576 2.49933 5.46162C2.99073 4.28747 3.8819 3.32517 5.01493 2.74523C5.07806 2.71337 5.1343 2.6694 5.18044 2.61581C5.22657 2.56222 5.2617 2.50007 5.28382 2.43291C5.30594 2.36575 5.31461 2.29488 5.30934 2.22437C5.30407 2.15385 5.28497 2.08506 5.25311 2.02193C5.22126 1.9588 5.17729 1.90256 5.1237 1.85642C5.07011 1.81029 5.00796 1.77516 4.9408 1.75304C4.80515 1.70837 4.65732 1.71942 4.52982 1.78375C3.17834 2.47149 2.11191 3.6128 1.5173 5.00777C0.922689 6.40274 0.837816 7.96243 1.27754 9.41369C1.71727 10.8649 2.65356 12.1152 3.92243 12.9456C5.19131 13.7759 6.71186 14.1334 8.21778 13.9553C9.7237 13.7773 11.119 13.0751 12.1592 11.9718C13.1995 10.8684 13.8184 9.43426 13.9076 7.92048C13.9968 6.40669 13.5505 4.90979 12.647 3.69194C11.7435 2.47409 10.4403 1.61293 8.96573 1.2593Z" fill={filteredStyles.fill}/>
    </svg>
  )
}